const cclaritiIntelIcon = 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883616/cclariti/cclariti_intel.svg';
const bpciCclaritiIcon = 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883618/cclariti/bpci_cclariti.svg';
const isCclaritiIntelProduct =
  'This report is part of the <b>CCLariti <span style="color: #e55a2f">Intel</span></b> subscription';
const isBPCICclaritiProduct =
  'This report is part of the <b><span style="color: #e55a2f">BPCI</span> CCLariti</b> subscription';

export default [
  {
    productId: 0, // productId: just a unique id. starts at 0 so you can do array[i] to get a Plan from PLANS_LIST
    planId: '0', // products belong to plans, so this refers to the plan this product is a part of
    stripePlanId: 0, // stripe ID for the plan (stripe tracks plans in their DB)
    stripePlanName: 'pac', // stripe makes us provide a name for the plan (doesn't have to be the display name, just used for identifying in stripe)
    title: 'PAC Flow', // title displayed in the app for this product
    description:
      'There’s a reason why <b>narrowing networks</b> is a key strategy for acute care hospitals; unravel how value-based reimbursement performance metrics are closely correlated to the <b>provider networks</b> you associate with.',
    remark: isCclaritiIntelProduct,
    icon: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883623/cclariti/circle_pac_icon.svg', // path to icon
    iconGroup: cclaritiIntelIcon,
    canCheckOut: true, // some products can't be 'self checkout' and user will need to send us a message through the contact form
    amount: '45000', // the price in cents
    // carouselImages are used to fill the carousel on the product
    // detail page, each slide has a caption (which is called text
    // in the array below)
    // array of objects { text: String, url: String
    carouselImages: [
      {
        text:
          'Insightful reporting of value-based reimbursement metrics on patients as they move through the acute and post-acute care continuum.',
        url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883620/cclariti/PAC_Flow_1.png',
      },
      {
        text:
          'Data-driven approach to evaluating “high” and “low” performing post-acute care partners of acute care providers.',
        url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883620/cclariti/PAC_Flow_2.png',
      },
      {
        text: 'Intuitive filtering for ease of benchmarking.',
        url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883619/cclariti/PAC_Flow_3.png',
      },
      {
        text: '“Metric Selector” for ease of benchmarking on various performance metrics.',
        url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883620/cclariti/PAC_Flow_4.png',
      },
      {
        text: 'Detailed reports that can be downloaded to excel for custom analysis claims metrics.',
        url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883619/cclariti/PAC_Flow_5.png',
      },
    ],
  },
  {
    productId: 1,
    planId: '0',
    stripePlanId: 0,
    title: 'Provider Deep-Dive',
    description:
      '<b>SWOT analysis</b> as it should be; <b>benchmark</b> cost of care, utilization and outcomes metrics with your peers, upstream referral sources and downstream partners.',
    remark: isCclaritiIntelProduct,
    icon: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883623/cclariti/circle_provider_icon.svg',
    iconGroup: cclaritiIntelIcon,
    canCheckOut: false,
    carouselImages: [
      {
        text:
          'Summary of the most important and relevant value-based-reimbursement metrics for acute care, skilled nursing facility and certified home healthcare providers.',
        url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883622/cclariti/Deep-Dive_1.png',
      },
      {
        text:
          'Extensive drill-down capabilities that facilitate data-driven approach to quality assurance and performance improvement activities.',
        url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883622/cclariti/Deep-Dive_2.png',
      },
      {
        text: 'Intuitive trending and benchmarking tools to easily assess your strengths and weaknesses.',
        url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883622/cclariti/Deep-Dive_3.png',
      },
      {
        text:
          'Dynamic comparison with your peers and referral sources for ease of identification of possible market differentiation and competitive selling strategies.',
        url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883623/cclariti/Deep-Dive_4.png',
      },
      {
        text: 'Detailed reports that can be downloaded to excel for custom analysis claims metrics.',
        url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883622/cclariti/Deep-Dive_5.png',
      },
    ],
  },
  {
    productId: 2,
    planId: '0',
    stripePlanId: 0,
    title: 'Quarterly Claims',
    description:
      'In the world of pay-for-performance, there are winners and there are losers; monitor <b>market share</b> and <b>patient volume trends</b> confirmed through quarterly reporting of Medicare claims data.',
    remark: isCclaritiIntelProduct,
    icon: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883625/cclariti/circle_quarterly_icon.svg',
    iconGroup: cclaritiIntelIcon,
    canCheckOut: false,
    carouselImages: [
      {
        text:
          'Use quarterly Medicare claims data to gain the most accurate and timely snapshot of the healthcare continuum.',
        url: 'https://res.cloudinary.com/dfq1pflmk/image/upload/v1598883616/cclariti/Quarterly_Flow_1.png',
      },
      {
        text: 'Detailed view of patient flow data between acute and post-acute providers.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523396405/Quarterly_Flow_2.png',
      },
      {
        text: 'Intuitive reports that reveal market dynamics within market segments and provider networks',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523396395/Quarterly_Flow_3.png',
      },
      {
        text: 'Trending of key market metrics to establish insights on how a market is evolving',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523396388/Quarterly_Flow_4.png',
      },
    ],
  },
  {
    productId: 3,
    planId: '1',
    stripePlanId: 1,
    title: 'BPCI Opportunity Analysis',
    description:
      'With BPCI Advanced, upstream and downstream providers will soon have an increased urgency to evaluate how strategic alliances will determine their success; Using episodic claims data to design your destiny in BPCI advanced.',
    remark: isBPCICclaritiProduct,
    icon: 'https://res.cloudinary.com/foundry41/image/upload/v1523396452/circle_bpci_opportunity_icon.svg',
    iconGroup: cclaritiIntelIcon,
    canCheckOut: false,
    carouselImages: [
      {
        text: 'Comprehensive view of historic performance to accurately frame opportunity for BPCI.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523395865/cclariti/BPCI_Opportunity_1.png',
      },
      {
        text: 'Benchmarking of key performance drivers to familiarize decision makers on sources for improvement.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523395863/cclariti/BPCI_Opportunity_2.png',
      },
      {
        text: 'Dynamic filtering of reports to make relationships between performance drivers more evident.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523395868/cclariti/BPCI_Opportunity_3.png',
      },
      {
        text: 'Define concrete targets for performance drivers to insure repeatability of results.',
        // text: 'Complex modelling of DRG, risk track and blending selections to maximize financial performance.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523395862/cclariti/BPCI_Opportunity_4.png',
      },
      // {
      //   text: 'Define concrete targets for performance drivers to insure repeatability of results.',
      //   url: '/BPCI_Opportunity_5.PNG',
      // },
    ],
  },
  // {
  //   productId: 4,
  //   planId: '1',
  //   stripePlanId: 1,
  //   title: 'BPCI Performance',
  //   description:
  //     'Going <b>live</b> in <b>BPCI</b>, now what; calibrate your execution plan through extensive <b>monthly BI dashboards</b> and <b>quarterly</b> segmentation and trending <b>analysis</b> of key performance drivers.',
  //   remark: isBPCICclaritiProduct,
  //   icon: 'https://res.cloudinary.com/foundry41/image/upload/v1523396452/circle_bpci_performance_icon.svg',
  //   iconGroup: bpciCclaritiIcon,
  //   canCheckOut: false,
  //   carouselImages: [
  //     {
  //       text: 'Monthly dashboards to closely monitor performance in BPCI program.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //     {
  //       text: 'Claims data is structured to maximize actionable insights on the various drivers of cost and outcomes.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //     {
  //       text: 'Dynamic filtering of reports to make relationships between performance drivers more evident.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //     {
  //       text: 'Segmentation of patient population that lead to a very deep understanding of your bundled population.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //     {
  //       text: 'Access to patient level reporting to facilitate extensive root-cause analysis.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //     {
  //       text: 'Trending and benchmarking of episode initiators within your BPCI Program.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //     {
  //       text:
  //         'Quarterly root-cause analysis to assist prioritization and follow through on performance improvement measures.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //     {
  //       text: 'On-going analysis of bundled selections to insure financial performance is optimized.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //     {
  //       text: 'Detailed reports that can be downloaded to excel for custom analysis claims metrics.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //   ],
  // },
  {
    productId: 5,
    planId: '0',
    stripePlanId: 1,
    title: 'Medicare.gov Data',
    description: 'Medicare.gov Data',
    remark: isCclaritiIntelProduct,
    icon: 'https://res.cloudinary.com/foundry41/image/upload/v1539135432/cclariti/k0rzppxnv9xqqr0ax60y.png',
    iconGroup: cclaritiIntelIcon,
    canCheckOut: false,
    carouselImages: [],
  },
];
[
  {
    productId: 0, // productId: just a unique id. starts at 0 so you can do array[i] to get a Plan from PLANS_LIST
    planId: '0', // products belong to plans, so this refers to the plan this product is a part of
    stripePlanId: 0, // stripe ID for the plan (stripe tracks plans in their DB)
    stripePlanName: 'pac', // stripe makes us provide a name for the plan (doesn't have to be the display name, just used for identifying in stripe)
    title: 'PAC Flow', // title displayed in the app for this product
    description:
      'There’s a reason why <b>narrowing networks</b> is a key strategy for acute care hospitals; unravel how value-based reimbursement performance metrics are closely correlated to the <b>provider networks</b> you associate with.',
    remark: isCclaritiIntelProduct,
    icon: 'https://res.cloudinary.com/foundry41/image/upload/v1523396450/circle_pac_icon.svg', // path to icon
    iconGroup: cclaritiIntelIcon,
    canCheckOut: true, // some products can't be 'self checkout' and user will need to send us a message through the contact form
    amount: '45000', // the price in cents
    // carouselImages are used to fill the carousel on the product
    // detail page, each slide has a caption (which is called text
    // in the array below)
    // array of objects { text: String, url: String
    carouselImages: [
      {
        text:
          'Insightful reporting of value-based reimbursement metrics on patients as they move through the acute and post-acute care continuum.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523396423/PAC_Flow_1.png',
      },
      {
        text:
          'Data-driven approach to evaluating “high” and “low” performing post-acute care partners of acute care providers.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523396428/PAC_Flow_2.png',
      },
      {
        text: 'Intuitive filtering for ease of benchmarking.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523396424/PAC_Flow_3.png',
      },
      {
        text: '“Metric Selector” for ease of benchmarking on various performance metrics.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523396414/PAC_Flow_4.png',
      },
      {
        text: 'Detailed reports that can be downloaded to excel for custom analysis claims metrics.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523396433/PAC_Flow_5.png',
      },
    ],
  },
  {
    productId: 1,
    planId: '0',
    stripePlanId: 0,
    title: 'Provider Deep-Dive',
    description:
      '<b>SWOT analysis</b> as it should be; <b>benchmark</b> cost of care, utilization and outcomes metrics with your peers, upstream referral sources and downstream partners.',
    remark: isCclaritiIntelProduct,
    icon: 'https://res.cloudinary.com/foundry41/image/upload/v1523395858/cclariti/circle_provider_icon.svg',
    iconGroup: cclaritiIntelIcon,
    canCheckOut: false,
    carouselImages: [
      {
        text:
          'Summary of the most important and relevant value-based-reimbursement metrics for acute care, skilled nursing facility and certified home healthcare providers.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523396449/Deep-Dive_1.png',
      },
      {
        text:
          'Extensive drill-down capabilities that facilitate data-driven approach to quality assurance and performance improvement activities.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523396445/Deep-Dive_2.png',
      },
      {
        text: 'Intuitive trending and benchmarking tools to easily assess your strengths and weaknesses.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523396455/Deep-Dive_3.png',
      },
      {
        text:
          'Dynamic comparison with your peers and referral sources for ease of identification of possible market differentiation and competitive selling strategies.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523396461/Deep-Dive_4.png',
      },
      {
        text: 'Detailed reports that can be downloaded to excel for custom analysis claims metrics.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523396453/Deep-Dive_5.png',
      },
    ],
  },
  {
    productId: 2,
    planId: '0',
    stripePlanId: 0,
    title: 'Quarterly Claims',
    description:
      'In the world of pay-for-performance, there are winners and there are losers; monitor <b>market share</b> and <b>patient volume trends</b> confirmed through quarterly reporting of Medicare claims data.',
    remark: isCclaritiIntelProduct,
    icon: 'https://res.cloudinary.com/foundry41/image/upload/v1523396447/circle_quarterly_icon.svg',
    iconGroup: cclaritiIntelIcon,
    canCheckOut: false,
    carouselImages: [
      {
        text:
          'Use quarterly Medicare claims data to gain the most accurate and timely snapshot of the healthcare continuum.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523396424/Quarterly_Flow_1.png',
      },
      {
        text: 'Detailed view of patient flow data between acute and post-acute providers.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523396405/Quarterly_Flow_2.png',
      },
      {
        text: 'Intuitive reports that reveal market dynamics within market segments and provider networks',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523396395/Quarterly_Flow_3.png',
      },
      {
        text: 'Trending of key market metrics to establish insights on how a market is evolving',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523396388/Quarterly_Flow_4.png',
      },
    ],
  },
  {
    productId: 3,
    planId: '1',
    stripePlanId: 1,
    title: 'BPCI Opportunity Analysis',
    description:
      'With BPCI Advanced, upstream and downstream providers will soon have an increased urgency to evaluate how strategic alliances will determine their success; Using episodic claims data to design your destiny in BPCI advanced.',
    remark: isBPCICclaritiProduct,
    icon: 'https://res.cloudinary.com/foundry41/image/upload/v1523396452/circle_bpci_opportunity_icon.svg',
    iconGroup: bpciCclaritiIcon,
    canCheckOut: false,
    carouselImages: [
      {
        text: 'Comprehensive view of historic performance to accurately frame opportunity for BPCI.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523395865/cclariti/BPCI_Opportunity_1.png',
      },
      {
        text: 'Benchmarking of key performance drivers to familiarize decision makers on sources for improvement.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523395863/cclariti/BPCI_Opportunity_2.png',
      },
      {
        text: 'Dynamic filtering of reports to make relationships between performance drivers more evident.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523395868/cclariti/BPCI_Opportunity_3.png',
      },
      {
        text: 'Define concrete targets for performance drivers to insure repeatability of results.',
        // text: 'Complex modelling of DRG, risk track and blending selections to maximize financial performance.',
        url: 'https://res.cloudinary.com/foundry41/image/upload/v1523395862/cclariti/BPCI_Opportunity_4.png',
      },
      // {
      //   text: 'Define concrete targets for performance drivers to insure repeatability of results.',
      //   url: '/BPCI_Opportunity_5.PNG',
      // },
    ],
  },
  // {
  //   productId: 4,
  //   planId: '1',
  //   stripePlanId: 1,
  //   title: 'BPCI Performance',
  //   description:
  //     'Going <b>live</b> in <b>BPCI</b>, now what; calibrate your execution plan through extensive <b>monthly BI dashboards</b> and <b>quarterly</b> segmentation and trending <b>analysis</b> of key performance drivers.',
  //   remark: isBPCICclaritiProduct,
  //   icon: 'https://res.cloudinary.com/foundry41/image/upload/v1523396452/circle_bpci_performance_icon.svg',
  //   iconGroup: bpciCclaritiIcon,
  //   canCheckOut: false,
  //   carouselImages: [
  //     {
  //       text: 'Monthly dashboards to closely monitor performance in BPCI program.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //     {
  //       text: 'Claims data is structured to maximize actionable insights on the various drivers of cost and outcomes.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //     {
  //       text: 'Dynamic filtering of reports to make relationships between performance drivers more evident.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //     {
  //       text: 'Segmentation of patient population that lead to a very deep understanding of your bundled population.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //     {
  //       text: 'Access to patient level reporting to facilitate extensive root-cause analysis.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //     {
  //       text: 'Trending and benchmarking of episode initiators within your BPCI Program.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //     {
  //       text:
  //         'Quarterly root-cause analysis to assist prioritization and follow through on performance improvement measures.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //     {
  //       text: 'On-going analysis of bundled selections to insure financial performance is optimized.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //     {
  //       text: 'Detailed reports that can be downloaded to excel for custom analysis claims metrics.',
  //       url: 'https://via.placeholder.com/550x350',
  //     },
  //   ],
  // },
  {
    productId: 5,
    planId: '0',
    stripePlanId: 1,
    title: 'Medicare.gov Data',
    description: 'Medicare.gov Data',
    remark: isCclaritiIntelProduct,
    icon: 'https://res.cloudinary.com/foundry41/image/upload/v1539135432/cclariti/k0rzppxnv9xqqr0ax60y.png',
    iconGroup: cclaritiIntelIcon,
    canCheckOut: false,
    carouselImages: [],
  },
];



// WEBPACK FOOTER //
// ./src/lib/constants/plans-list.js